var map = {
	"./decidim/avatar-multiuser.png": 87613,
	"./decidim/brands/facebook.svg": 61417,
	"./decidim/brands/google.svg": 46464,
	"./decidim/brands/twitter-x.svg": 28661,
	"./decidim/cc-badge.png": 45131,
	"./decidim/decidim-logo.svg": 1695,
	"./decidim/default-avatar.svg": 88147,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 30969,
	"./decidim/icons.svg": 67170,
	"./decidim/pattern.png": 19265,
	"./decidim/placeholder-card-g.svg": 43118,
	"./decidim/placeholder-card-l.svg": 92741,
	"./decidim/placeholder.jpg": 28788,
	"./decidim/remixicon.symbol.svg": 70294,
	"./decidim/vendor/social-share-button/douban.svg": 76889,
	"./decidim/vendor/social-share-button/email.svg": 33754,
	"./decidim/vendor/social-share-button/facebook.svg": 80466,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 93150,
	"./decidim/vendor/social-share-button/hacker_news.svg": 3034,
	"./decidim/vendor/social-share-button/linkedin.svg": 13864,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 34753,
	"./decidim/vendor/social-share-button/pinterest.svg": 95876,
	"./decidim/vendor/social-share-button/reddit.svg": 46910,
	"./decidim/vendor/social-share-button/telegram.svg": 31679,
	"./decidim/vendor/social-share-button/tumblr.svg": 42268,
	"./decidim/vendor/social-share-button/twitter.svg": 91631,
	"./decidim/vendor/social-share-button/vkontakte.svg": 63501,
	"./decidim/vendor/social-share-button/wechat.svg": 53328,
	"./decidim/vendor/social-share-button/whatsapp.svg": 67056,
	"./decidim/vendor/social-share-button/x.svg": 84218,
	"./decidim/vendor/social-share-button/xing.svg": 22222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42956;